<template>
  <div class="pane-box">

    <div class="pane-activity">

      <el-timeline :reverse="false" style="display: flex;flex-direction: column; width: 400px;">

        <el-timeline-item placement="top" color="#00a5d5" v-for="(item,index) in activityDataList" :key="item.activityId"
          :timestamp="item.createTime">
          <el-card style="min-width: 300px;font-size:13px;">
            <span v-if="item.activityType=='3' || item.activityType=='4'" style="color: red;">{{item.activityContent}}</span>
            <span v-else>{{item.activityContent}}</span>
           <div v-if="item.reasonImages" show-close="true" v-for="(val,key) in item.index">
               <img @click="switchSta(index,key)" class="el-card-img" :src="val"/>
               <el-dialog v-if="item.reasonImages" :visible.sync="dialogVisible" custom-class="customWidth" :modal-append-to-body="false"
                z-index="4000">
                   <img width="100%" :src="activityDataList[count].index[num]"/>
                </el-dialog>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

  </div>

</template>

<script>
  import {
    mapState
  } from 'vuex'
  import BaseTag from '/components/BaseTag'
  export default {
    props: {
      orderDetail: {
        type: Object,
        default: null
      },
    },
    computed: {
      activityDataList() {
        var activityDataList = this.orderDetail.activityList;
        activityDataList.sort(function(a, b) {
          return a.createTime > b.createTime ? 1 : -1; // 正序
        });
        return activityDataList;
      }
    },
    data() {
      return {
        dataList: [],
        reasonImages : "",
        dialogVisible : false,
        num:0,
        count:0,
        reasonImagesList:[]
      }
    },
    methods: {
      switchSta(index,key){
          this.count = index;
          this.num = key;
          this.dialogVisible = true;
      },
      many(){
        this.activityDataList.filter((item,index)=>{
            item.index = item.reasonImages.split(',')
        })
      }
    },
    created() {
      this.many()
    },
    mounted() {
      // this.dataList = this.orderDetail.activityList;
      // this.dataList.sort(function(a, b) {
      //   return a.activityTime - b.activityTime; //	降序，升序则反之
      // });
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";

  .pane-activity {
    padding: 0 15px;
  }

  .el-timeline {
      margin: 0;
      font-size: 14px;
      list-style: none;
      display: flex;
      flex-direction: column;
      width: 380px;
  }

  .el-card__body {
    padding: 10px 15px;
  }
  .el-card-img {
    width: 100px;
    height: 100px;
    margin: 10px 5px 10px 0;
    border-radius: 5%;
    float: left;
  }
  .customWidth{
	  width: 35% !important;
	  min-width: 100px !important;
  }
</style>



// WEBPACK FOOTER //
// detailActivity.vue?e915478c